var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLocations = function SvgLocations(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      width: "100%",
      height: "auto",
      fill: "currentColor"
    },
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 19h-2V1h2v1h9a1 1 0 0 1 .89.55 1 1 0 0 1-.09 1.05L20.25 7l2.55 3.4a1 1 0 0 1 .09 1 1 1 0 0 1-.89.6h-9zm9.13-1.78C20.72 15.85 17.92 15 15 15.14l.07 2C18.69 17 20.92 18.49 21 19c-.15.55-3.15 2-9 2s-8.85-1.46-9-2c.08-.53 2.27-2 6-1.88l.06-2c-3-.11-5.8.72-7.2 2.09A2.46 2.46 0 0 0 0 19c0 2.75 5.7 4 11 4s11-1.25 11-4a2.46 2.46 0 0 0-.87-1.78z"
  })));
};
export default SvgLocations;